import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Certificate {
    code: string;
    type: CertificateType;
    description: string;
    description_nl_be: string;
    description_en_us: string;
    description_fr_fr: string;
    description_de_de: string;
    update_timestamp: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateCertificate {
    code?: string;
    type?: CertificateType;
    description?: string;
    description_nl_be?: string;
    description_en_us?: string;
    description_fr_fr?: string;
    description_de_de?: string;
}

export interface UpdateCertificate {
    code?: string | null;
    type?: CertificateType | null;
    description?: string | null;
    description_nl_be?: string | null;
    description_en_us?: string | null;
    description_fr_fr?: string | null;
    description_de_de?: string | null;
}

export enum QueryParams {
    EQUIPMENT_ID = 'equipment_id',
    USER_ID = 'user_id',
    PRODUCT_ID = 'product_id',
    TYPE = 'type'
}
export type CertificateQueryParams = DefaultQueryParams & QueryParams;
export type CertificateListResponse = PaginatedResponse<Certificate>;

export enum CertificateType {
    EQUIPMENT = 'equipment',
    USER = 'user'
}